require("packs/user_profile_popup");
require("packs/comment_actions");
require("packs/bookmarks");
require("packs/reactions");
require("packs/comment_events");
require("packs/badge_popup");
import "stylesheets/swiper-styles";
require("packs/original_image");
import { showToast } from "./notification_toast";
import { setBadgePopup } from "packs/badge_popup";
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
window.Swiper = Swiper;
Swiper.use([Navigation, Pagination, FreeMode]);

// Image color extraction for user photo background
function getMostProminentColor(imageData) {
  let colorCount = {};
  let maxCount = 0;
  let dominantColor = { r: 128, g: 128, b: 128 };

  for (let i = 0; i < imageData.length; i += 4) {
    const r = imageData[i];
    const g = imageData[i + 1];
    const b = imageData[i + 2];
    const color = `${r},${g},${b}`;

    colorCount[color] = (colorCount[color] || 0) + 1;
    if (colorCount[color] > maxCount) {
      maxCount = colorCount[color];
      dominantColor = { r, g, b };
    }
  }
  return dominantColor;
}

window.handleUserPhotoColor = function() {
  const image = document.getElementById("user-photo");
  const resultDiv = document.getElementById("user-photo-parent");
  if (!image || !resultDiv) return;

  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, image.width, image.height);

  const imageData = ctx.getImageData(0, 0, image.width, image.height).data;
  const color = getMostProminentColor(imageData);
  resultDiv.style.backgroundColor = `rgba(${color.r}, ${color.g}, ${color.b}, .3)`;
};

document.querySelector("#reload-page")?.addEventListener("ajax:success", function (event) {
  location.reload();
});

let userBio = document.getElementById("user-bio-content");
let userBioExpand = document.getElementById("user-bio-expand");
let userBioFill = document.getElementById("user-bio-fill");

if (userBio && userBioExpand) {
  userBioExpand.addEventListener("click", function () {
    let isCollapsed = userBioExpand.classList.contains("opened");
    userBioExpand.textContent = isCollapsed
      ? I18n.t("read_more")
      : I18n.t("less");
    if(this.classList.contains('opened')){
      this.classList.remove('opened');
      userBioFill.innerText = userBio.getAttribute('data-bio').substring(0,70) + ' ...';
    }
    else{
      this.classList.add('opened');
      userBioFill.innerText = userBio.getAttribute('data-bio');
    }  
  });
}

let adminSection = document.getElementById("admin-section-expand");
let adminActions = document.querySelector(".admin-section");
let modActions = document.querySelector(".mod-options-section");

if (adminSection) {
  adminSection.addEventListener("click", function() {
    this.classList.toggle("open");
    if (this.classList.contains("open")) {
      this.querySelector("svg").classList.add("rotate-180");
      adminActions?.classList.remove("hidden");
      modActions?.classList.remove("hidden");
    } else {
      this.querySelector("svg").classList.remove("rotate-180");
      adminActions?.classList.add("hidden");
      modActions?.classList.add("hidden");
    }
  })
}

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth < 768) {
    setTimeout(() => {
      const activeTab = document.querySelector('.tab[role="active-tab"]');
      if (activeTab) {
        // this is to scroll to the tab that user clicked to
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
      }
    }, 1000)
  }
  document.querySelectorAll('[id^="follow-link-"]')?.forEach(link => {
    link.addEventListener('ajax:success', (event) => {
      const linkElement = event.currentTarget;
      const action = linkElement.dataset.action;
      if (action === 'unfollow') {
        linkElement.innerHTML = I18n.t('undo');
        linkElement.dataset.action = 'follow';
        linkElement.href = linkElement.href.replace('remove=1', '');
        showToast(I18n.t('successfully_unfollowed'));
      } else if (action === 'follow') {
        linkElement.innerHTML = I18n.t('following');
        linkElement.dataset.action = 'unfollow';
        linkElement.href = `${linkElement.href}&remove=1`;
        showToast(I18n.t('successfully_followed'));
      }
    });
  });
  // function showFlashMessage(type, message) {
  //   const existingFlash = document.getElementById('flash-message');
  //   const flashText = document.getElementById('flash-message-text');
  //   if (existingFlash) {
  //     existingFlash.classList.remove('opacity-0');
  //     existingFlash.classList.add('opacity-100');
  //     if (type === 'success') {
  //       existingFlash.classList.add('bg-secondary-light');
  //       existingFlash.classList.remove('bg-red-500');
  //     } else if (type === 'error') {
  //       existingFlash.classList.add('bg-red-500');
  //       existingFlash.classList.remove('bg-secondary-light');
  //     }
  //     flashText.textContent = message;
  //     setTimeout(() => {
  //       existingFlash.classList.remove('opacity-100');
  //       existingFlash.classList.add('opacity-0');
  //     }, 3000);
  //   }
  // }
  let flashClose = document.querySelector('.flash-close');
  if (flashClose) {
    flashClose.addEventListener('click', function() {
      const flashMessage = document.getElementById('flash-message');
      flashMessage.classList.remove('opacity-100');
      flashMessage.classList.add('opacity-0');
    });
  }
});

document.addEventListener("ajax:success", function (event) {
  if (event.target.matches("#reload-page")) {
    location.reload();
  }
});


document.addEventListener("DOMContentLoaded", () => {
  setBadgePopup();
  
  // Set widths first, then initialize swiper with proper delay
  setResponsiveBadgeWidths();
  
  setTimeout(() => {
    setUpSwiper();
    // Update swiper after it's initialized to ensure proper sizing
    setTimeout(() => {
      const swiperInstance = document.querySelector('.test-swiper')?.swiper;
      if (swiperInstance) {
        swiperInstance.updateSize();
        swiperInstance.updateSlides();
        swiperInstance.update();
      }
    }, 100);
  }, 100);
  
  // Update widths on window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setResponsiveBadgeWidths();
      // Update swiper after width changes
      const swiperInstance = document.querySelector('.test-swiper')?.swiper;
      if (swiperInstance) {
        swiperInstance.updateSize();
        swiperInstance.updateSlides();
        swiperInstance.update();
      }
    }, 250);
  });
})

function setUpSwiper() {
  if (!document.querySelector('.test-swiper')) return;

  let swiperHomepageWidget = new Swiper('.test-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: false,
      momentum: true,
      momentumRatio: 1,
      momentumVelocityRatio: 1,
      momentumBounce: false,
    },
    allowTouchMove: true,
    resistanceRatio: 0,
    watchOverflow: false,
    watchSlidesProgress: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
      hideOnClick: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        freeMode: {
          enabled: true,
        },
      },
      1280: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        freeMode: {
          enabled: false,
        },
        spaceBetween: 0,
      },
    },
  });
  swiperHomepageWidget.update();
  swiperHomepageWidget.slideTo(0);
}

function setResponsiveBadgeWidths() {
  const isMobile = window.innerWidth < 768;
  const badgeWidth = isMobile ? 115 : 170;
  
  // Update VIP badge slide widths
  document.querySelectorAll('.test-swiper .swiper-slide').forEach(slide => {
    slide.style.width = `${badgeWidth}px`;
    slide.style.minWidth = `${badgeWidth}px`;
    slide.style.maxWidth = `${badgeWidth}px`;
  });
  
  // Update regular badge widths in non-swiper sections
  document.querySelectorAll('.badge-open-popup').forEach(badge => {
    // Skip if it's inside a swiper (already handled above)
    if (!badge.classList.contains('swiper-slide')) {
      badge.style.width = `${badgeWidth}px`;
      badge.style.minWidth = `${badgeWidth}px`;
      badge.style.maxWidth = `${badgeWidth}px`;
    }
  });
  
  // Update badge containers
  document.querySelectorAll('.badge-container').forEach(container => {
    const badgeCount = parseInt(container.dataset.badgeCount) || 0;
    if (badgeCount > 0) {
      const width = badgeCount * badgeWidth + (badgeCount - 1);
      container.style.width = `${width}px`;
    } else {
      container.style.width = '100%';
    }
  });
  
  // Update progress bars
  document.querySelectorAll('.progress-bar').forEach(progressBar => {
    const badgeCount = parseInt(progressBar.dataset.badgeCount) || 0;
    if (badgeCount > 0) {
      const width = badgeCount * badgeWidth + (badgeCount - 1);
      progressBar.style.width = `${width}px`;
    } else {
      progressBar.style.width = '100%';
    }
  });
}
// Profile groups horizontal scroll
function initProfileGroupsScroll() {
  var container = document.getElementById('profile-groups-scroll');
  var leftBtn = document.getElementById('profile-groups-left-btn');
  var rightBtn = document.getElementById('profile-groups-right-btn');
  var rightFade = document.getElementById('profile-groups-fade');
  var leftFade = document.getElementById('profile-groups-left-fade');
  if (!container || !leftBtn || !rightBtn || !rightFade) return;

  function update() {
    var atStart = container.scrollLeft <= 0;
    var atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    var hasOverflow = container.scrollWidth > container.clientWidth;

    if (!hasOverflow || atStart) {
      leftBtn.style.opacity = '0';
      leftBtn.style.pointerEvents = 'none';
      if (leftFade) leftFade.style.opacity = '0';
    } else {
      leftBtn.style.opacity = '1';
      leftBtn.style.pointerEvents = 'auto';
      if (leftFade) leftFade.style.opacity = '1';
    }

    if (!hasOverflow || atEnd) {
      rightBtn.style.opacity = '0';
      rightBtn.style.pointerEvents = 'none';
      rightFade.style.opacity = '0';
    } else {
      rightBtn.style.opacity = '1';
      rightBtn.style.pointerEvents = 'auto';
      rightFade.style.opacity = '1';
    }
  }

  leftBtn.addEventListener('click', function() {
    container.scrollBy({ left: -150, behavior: 'smooth' });
  });
  rightBtn.addEventListener('click', function() {
    container.scrollBy({ left: 150, behavior: 'smooth' });
  });
  container.addEventListener('scroll', update);
  update();
}

document.addEventListener('DOMContentLoaded', function() {
  initProfileGroupsScroll();
  var topics_to_blur = document.getElementById("topics-to-blur");

  if (topics_to_blur) {
    var topic_ids = topics_to_blur.dataset.topics;

    if (topic_ids) {
      var topic_ids = JSON.parse(topic_ids);
      for (var i = 0; i < topic_ids.length; i++) {
        var topic_to_blur = topic_ids[i];
        var imageElement = document.getElementById("deal_posted_" + topic_to_blur);

        if (imageElement) {
          imageElement.classList.add("blur");
        }
      }
    }
  }
});

